import { CdkDragDrop, CdkDragMove } from '@angular/cdk/drag-drop'
import { Component, Input, OnInit } from '@angular/core'
import { BadgeElement, BadgeElementFieldType } from '../../../models/badge-variable-elements.model'
import { BadgeEditorService } from '../../../services/badge-editor.service'
import { TemplateLayout } from '../../../types/badge.type'
import { CommonModule } from '@angular/common'
import { SafeDomPipe } from '@app/v2/shared/pipes/safe-dom.pipe'
import { DragDropModule } from '@angular/cdk/drag-drop'
@Component({
  selector: 'app-variable-element',
  templateUrl: './variable-element.component.html',
  styleUrls: ['./variable-element.component.scss'],
  standalone: true,
  imports: [CommonModule, SafeDomPipe, DragDropModule]
})
export class VariableElementComponent implements OnInit {
  @Input() public selectedTemplate!: TemplateLayout | null
  @Input() public variableElement!: BadgeElement

  public variableElementLabel: string = ''

  constructor(private _BadgeService: BadgeEditorService) {}

  ngOnInit(): void {
    this.variableElementLabel = this.variableElement.label?.startsWith('Parent: ') ? this.variableElement.label?.replace('Parent: ', '') : this.variableElement.label || 'Field'
    this._initiateVariableElementStyle()
  }

  /**
   * @method onElementDragStart
   * @description Set the cursor to grabbing when the element is being dragged
   * @returns void
   */
  public onElementDragStart(): void {
    document.body.style.cursor = 'grabbing'
    this.variableElement.id = crypto.randomUUID()
    this._BadgeService.isDraggingStarted$.next({ ...this.variableElement })
  }

  /**
   * @method onElementMove
   * @description Check if the element is being dragged inside the badge
   * @param event CdKDragMove
   * @returns void
   */
  public onElementMove(event: CdkDragMove): void {
    const target = document.elementFromPoint(event.pointerPosition.x, event.pointerPosition.y) as HTMLElement
    if (!target) return
    document.querySelectorAll('.temporary-element.drop-area').forEach((dropArea) => dropArea?.classList.remove('active-drop-area'))
    const targetElement = target.classList.contains('spanned-drop-area') ? (target?.parentElement as HTMLElement) : target
    if (targetElement?.classList.contains('drop-area')) targetElement.classList.add('active-drop-area')
    const isInsideBadge = !!target.closest('#badge')
    this._BadgeService.isDragging$.next(isInsideBadge)
  }

  /**
   * @method onElementDrop
   * @description Check if the element has been dropped inside the badge
   * @param event CdkDragDrop<BadgeElement>
   * @returns void
   */
  public onElementDrop(event: CdkDragDrop<BadgeElement>): void {
    const badge = document.querySelector('#badge') as HTMLDivElement
    const target = document.elementFromPoint(event.dropPoint.x, event.dropPoint.y) as HTMLElement
    document.body.style.cursor = 'default'
    this._BadgeService.isDragging$.next(false)
    const targetElement = target?.classList.contains('spanned-drop-area') ? (target.parentElement as HTMLElement) : target
    const isInsideBadge = targetElement.closest('#badge') || targetElement.id === 'drop-zone' || badge.classList.contains('invalid-dropping')
    if (!isInsideBadge) return
    this.variableElement.targetElement = targetElement
    this.variableElement.id = this.variableElement.previous = crypto.randomUUID()
    this._BadgeService.hasDropped$.next({ ...this.variableElement })
  }

  /**
   * @method _initiateVariableElementStyle
   * @description Initiate variable element style
   * @returns void
   */
  private _initiateVariableElementStyle(): void {
    switch (this.variableElement.field_type.toUpperCase()) {
      case BadgeElementFieldType.UPLOAD_PHOTO: {
        this.variableElement.style = {
          ...this.variableElement.style,
          height: '20mm',
          'border-radius': '0%',
          'justify-content': 'center'
        }
        break
      }
      case BadgeElementFieldType.QR_CODE: {
        this.variableElement.style = {
          ...this.variableElement.style,
          height: '20mm',
          'justify-content': 'center'
        }
        break
      }
      case BadgeElementFieldType.DTCM_QR_CODE: {
        this.variableElement.style = {
          ...this.variableElement.style,
          height: '6mm',
          'justify-content': 'center'
        }
        break
      }
      case BadgeElementFieldType.PERSONA_NAME: {
        this.variableElement.style = {
          ...this.variableElement.style,
          height: '6mm',
          'justify-content': 'center',
          'font-weight': 'bold'
        }
        break
      }
      case BadgeElementFieldType.PARENT_PERSONA_NAME: {
        this.variableElement.style = {
          ...this.variableElement.style,
          height: '6mm',
          'justify-content': 'center',
          'font-weight': 'bold'
        }
        break
      }
      default: {
        this.variableElement.style = {
          ...this.variableElement.style,
          height: '6mm',
          'justify-content': 'center'
        }
        break
      }
    }
  }
}
